import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import AppState from './context/AppState'
import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap/dist/js/bootstrap.bundle.min';
// PrimeReact theme, core and icons from the installed packages, pinned
// by package.json — these used to be unversioned unpkg links in
// public/index.html, so an upstream release could change the page
// without a deploy on our side.
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
// leaflet/dist/leaflet.css is now imported locally by the map-using
// components so it's only downloaded when a map page is visited.
import './utils/dayjsConfig'; // registers dayjs plugins before any component runs
import './pages/lywo/multiLang/i18n'
import './assets/css/Pristan_Css/main.scss'

// production: silence chatter, but keep console.error and console.warn —
// they are what a support engineer needs from a user's DevTools.
if (process.env.NODE_ENV === 'production') {
  console.log = () => { }
  console.debug = () => { }
  console.info = () => { }
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <AppState>
      <App />
    </AppState>
  </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
